import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'credit-card-payment-status-dialog',
  templateUrl: './credit-card-payment-status-dialog.component.html',
  styleUrls: ['./credit-card-payment-status-dialog.component.scss'],
})
export class CreditCardPaymentStatusDialogComponent implements OnInit {
  @Input() data;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() { }

}
